import { render } from "./VehiclesKPI.vue?vue&type=template&id=72239261&ts=true"
import script from "./VehiclesKPI.vue?vue&type=script&lang=ts"
export * from "./VehiclesKPI.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__